import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const CategoriesNavStyled = styled.aside`
  min-width: ${props => props.theme.menuPage.nav.width};
  max-width: ${props => props.theme.menuPage.nav.maxWidth};
  display: ${p => p.theme.menuPage.nav.display.desktop};
  position: relative;
  flex-wrap: wrap;
  z-index: 2;
  ${media.medium`
    display: ${p => p.theme.menuPage.nav.display.tablet};
  `};
  ${media.small`
    display: none;
  `};
  div {
    position: relative;
    width: 100%;
  }
`;

export const CategoryWrapper = styled.div`
  border-bottom: ${p => p.isTemplateLight ? `${p.theme.borderColor} solid 0.2rem` : 0};
  z-index: 3;
  position: relative;
`;

export const CategoriesNavLinkStyled = styled.a`
  display: flex;
  justify-content: ${p => p.isTemplateLight ? 'center' : 'flex-start'};
  align-items: center;
  cursor: pointer;
  font-family: ${p => p.theme.menuPage.nav.fontFamily};
  font-weight: ${p => p.theme.menuPage.nav.fontWeight};
  line-height: ${p => p.theme.menuPage.nav.lineHeight};
  color: ${props => props.theme.menuPage.nav.color};
  background-color: ${props => props.theme.menuPage.nav.backgroundColor};
  font-size: ${props => props.theme.menuPage.nav.fontSize};
  padding: ${props => props.theme.menuPage.nav.padding};
  width: ${p => p.theme.menuPage.nav.width};
  height: ${p => p.theme.menuPage.nav.height};
  border-bottom: ${p => p.isTemplateLight ? 0 : `${p.theme.borderColor} solid ${p.theme.borderWidth}`};
  text-transform: ${p => p.theme.menuPage.nav.textTransform};
  flex-grow: 1;
  &:hover {
    color: ${props => props.theme.tertiaryColor};
    background-color: ${props => props.theme.secondaryBackground};
  }
`;



// WEBPACK FOOTER //
// ./containers/MenuPage/CategoriesNav.style.js